/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   CurrentSearchView actions
 */

import type { CurrentSearchPOICategories } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  BEGIN_SHIMMER,
  CLEAR_TOAST_TYPE,
  FINISH_SHIMMER,
  HIDE_MARKERS,
  RESET_TOGGLE_VALUE,
  SET_FREEZE_BOX,
  SET_SAVED_SEARCH_EMAIL,
  SET_SELECTED_POI_CATEGORY,
  SET_SHOW_NIGHTLY_PRICE,
  SET_TOAST_TYPE,
  SET_TOGGLE_VALUE,
  SHOW_MARKERS,
} from '../constants/index'

export const beginShimmer = createAction<typeof BEGIN_SHIMMER>(BEGIN_SHIMMER)
export const finishShimmer = createAction<typeof FINISH_SHIMMER>(FINISH_SHIMMER)

export const showMarkers = createAction<typeof SHOW_MARKERS>(SHOW_MARKERS)
export const hideMarkers = createAction<typeof HIDE_MARKERS>(HIDE_MARKERS)

export const setShowNightlyPrice = createAction<boolean, typeof SET_SHOW_NIGHTLY_PRICE>(
  SET_SHOW_NIGHTLY_PRICE
)

export const setFreezeBox = createAction<boolean, typeof SET_FREEZE_BOX>(SET_FREEZE_BOX)

export const setSavedSearchEmail = createAction<string, typeof SET_SAVED_SEARCH_EMAIL>(
  SET_SAVED_SEARCH_EMAIL
)

export const setSelectedPoiCategory = createAction<
  CurrentSearchPOICategories | '' | null,
  typeof SET_SELECTED_POI_CATEGORY
>(SET_SELECTED_POI_CATEGORY)

export const setToastType = createAction<string, typeof SET_TOAST_TYPE>(SET_TOAST_TYPE)
export const clearToastType = createAction<typeof CLEAR_TOAST_TYPE>(CLEAR_TOAST_TYPE)

export const setToggleValue = createAction<
  'split' | 'full-list' | 'full-map' | '',
  typeof SET_TOGGLE_VALUE
>(SET_TOGGLE_VALUE)
export const resetToggleValue = createAction<typeof RESET_TOGGLE_VALUE>(RESET_TOGGLE_VALUE)
